module.exports = __webpack_public_path__ + "static/media/pills.6813ee83.svg";